/**
 * Presentation helpers for the playbook editor. Colour discipline follows
 * the workbench's: teal for live (it acts), quiet for the rest; red only for
 * a problem that stops publishing.
 */

import type { PlaybookMode } from '@/types/playbook';

export const MODE_CHIP: Record<PlaybookMode, { label: string; color: string; variant: string }> = {
  off: { label: 'Off', color: 'gray', variant: 'outline' },
  live: { label: 'Live', color: 'teal', variant: 'filled' },
};

/** "2 Oct 2026, 14:05" — or "—". */
export function formatWhen(iso: string | null | undefined): string {
  if (!iso) {
    return '—';
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** `client_material` → "client material". */
export function words(value: string | null | undefined): string {
  return (value ?? '').replace(/_/g, ' ');
}

export function playbookPath(key: string): string {
  return `/admin/playbooks/${encodeURIComponent(key)}`;
}

/** A comma-separated list as the form takes it, trimmed and deduplicated. */
export function listFrom(text: string): string[] {
  return [
    ...new Set(
      text
        .split(/[,\n]/)
        .map((part) => part.trim())
        .filter(Boolean)
    ),
  ];
}
